(function () {
  var QB_DISCOUNT_HANDLES = [''];
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || ((window.themeVariables || {}).settings || {}).moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(v, d) { return v == null || v !== v ? d : v; }
    function formatWithDelimiters(n, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal   = defaultTo(decimal, '.');
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr;
    }
    var value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':                              value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':                  value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_space_separator':         value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_with_comma_separator':         value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_with_apostrophe_separator':    value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_comma_separator':     value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator':     value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_no_decimals_with_apostrophe_separator':value = formatWithDelimiters(cents, 0, "'"); break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  /**
   * PDP / Quick Add：variant 切换时用元字段折扣率覆盖 theme.js 的默认价格渲染。
   * theme.js 的 ProductMeta._updatePrices 监听在 form 元素上，本监听在 document 上，
   * 因注册顺序靠后，会在 theme.js 更新之后执行，确保覆盖正确。
   */
  document.addEventListener('variant:changed', function (e) {
    var variant = e.detail.variant;
    var form = e.target;

    // 优先从 quick-buy 容器内查找 product-meta，避免跨弹窗选错
    var quickBuy = form.closest('quick-buy-drawer, quick-buy-popover');
    var formId = form.id;
    var productMeta = (quickBuy ? quickBuy.querySelector('product-meta') : null)
      || (formId ? document.querySelector('product-meta[form-id="' + formId + '"]') : null)
      || form.closest('product-meta')
      || document.querySelector('product-meta');
    if (!productMeta) return;

    var productHandle = productMeta.getAttribute('data-product-handle') || '';

    // 折扣数据查找优先级：
    // 1. quick-buy 容器内 [data-qb-discounts]（随 innerHTML 加载的内部 span）
    // 2. quick-buy-drawer/popover 元素自身 data-variant-discounts（product-item.liquid 注入，
    //    _load() 只替换 innerHTML 不影响元素属性，卡片切换变体后仍可靠存在）
    // 3. product-meta[data-variant-discounts]（PDP / quick-buy 原有方式）
    // 4. window.variantDiscounts（PDP script 注入）
    var discountPct = 0;
    var discountSource = (quickBuy && (quickBuy.querySelector('[data-qb-discounts]') || {dataset: {}}).dataset.qbDiscounts)
      || (quickBuy && quickBuy.dataset.variantDiscounts)
      || productMeta.dataset.variantDiscounts;
    if (discountSource) {
      try {
        var attrMap = JSON.parse(discountSource);
        discountPct = attrMap[String(variant.id)] || 0;
      } catch (_) {}
    }
    if (!discountPct) {
      discountPct = ((window.variantDiscounts || {})[String(variant.id)]) || 0;
    }
    var rawDiscountPct = discountPct;
    var navLabelPct = discountPct;

    var priceList = productMeta.querySelector('[data-product-price-list]');
    var labelList = productMeta.querySelector('[data-product-label-list]');
    if (!priceList) return;

    var settings = (window.themeVariables || {}).settings || {};
    var strings  = (window.themeVariables || {}).strings  || {};
    var fmt = settings.currencyCodeEnabled
      ? settings.moneyWithCurrencyFormat
      : settings.moneyFormat;
    // price-class 由 product-meta 属性决定（PDP 有 price--large，quick-buy 没有）
    var priceClass = productMeta.getAttribute('price-class') || '';

    // 吸底栏统一：所有 product（discount_percentage > 0）都展示 原价 + 折扣标签（navigator 效果）
    var stickyPrice = document.querySelector('[data-sticky-discount-price]');
    if (stickyPrice && rawDiscountPct > 0) {
      stickyPrice.innerHTML =
        '<span class="price-list" style="align-items:center;">' +
          '<span class="price">' + formatMoney(variant.price, fmt) + '</span>' +
          '<span class="label label--highlight">' + rawDiscountPct + '% off in cart</span>' +
        '</span>';
    }

    // navigator-t66：只展示原价 + 折扣标签（PDP / quick-buy）
    if (navLabelPct > 0) {
      priceList.innerHTML =
        '<span class="price ' + priceClass + '">' +
          '<span class="visually-hidden">' + (strings.productRegularPrice || '') + '</span>' +
          formatMoney(variant.price, fmt) +
        '</span>' +
        '<span class="label label--highlight">' + navLabelPct + '% off in cart</span>';

      if (labelList) labelList.innerHTML = '';
      return;
    }

    // quick-buy 内 ProductMeta 可能因 innerHTML 时序未注册监听，
    // 需要由本处理器全权负责价格渲染（含无折扣变体，防止切换后显示残留价格）
    if (!quickBuy) return; // PDP 由 theme.js ProductMeta 处理
    if (variant.compare_at_price > variant.price) {
      priceList.innerHTML =
        '<span class="price price--highlight ' + priceClass + '">' +
          '<span class="visually-hidden">' + (strings.productSalePrice || '') + '</span>' +
          formatMoney(variant.price, fmt) +
        '</span>' +
        '<span class="price price--compare">' +
          '<span class="visually-hidden">' + (strings.productRegularPrice || '') + '</span>' +
          formatMoney(variant.compare_at_price, fmt) +
        '</span>';
    } else {
      priceList.innerHTML =
        '<span class="price ' + priceClass + '">' +
          '<span class="visually-hidden">' + (strings.productSalePrice || '') + '</span>' +
          formatMoney(variant.price, fmt) +
        '</span>';
    }
    if (labelList) labelList.innerHTML = '';
  });

  /**
   * 产品卡片：颜色 swatch 切换时更新价格。
   * querySelector 限定在 .product-item-meta 内，防止 quick-buy-drawer
   * 加载后其内部的 [data-product-price-list] 被错误命中。
   */
  document.addEventListener('change', function (e) {
    var swatch = e.target.closest
      ? e.target.closest('.product-item-meta__swatch-list .color-swatch__radio')
      : null;
    if (!swatch) return;

    var productItem = swatch.closest('product-item');
    if (!productItem) return;

    var priceList = productItem.querySelector('[data-card-price-list][data-product-price-list]');
    if (!priceList) return;

    var price         = parseInt(swatch.getAttribute('data-variant-price') || '0', 10);
    var rawPct        = parseInt(swatch.getAttribute('data-variant-discount-pct') || '0', 10);
    var discountPct    = rawPct;
    if (!price) return;

    var strings = (window.themeVariables || {}).strings || {};

    if (discountPct > 0) {
      var discountedCents = price - Math.floor(price * discountPct / 100);

      priceList.innerHTML =
        '<span class="price price--highlight">' +
          '<span class="visually-hidden">' + (strings.productSalePrice || '') + '</span>' +
          formatMoney(discountedCents) +
        '</span>' +
        '<span class="price price--compare">' +
          '<span class="visually-hidden">' + (strings.productRegularPrice || '') + '</span>' +
          formatMoney(price) +
        '</span>';
    } else {
      priceList.innerHTML =
        '<span class="price">' +
          '<span class="visually-hidden">' + (strings.productSalePrice || '') + '</span>' +
          formatMoney(price) +
        '</span>';
    }

    // 产品卡片切换颜色后，若弹窗已加载（href 被移除），重新选中变体触发价格更新，
    // 否则 _onColorSwatchChanged 无法找到已加载的弹窗元素来更新 href。
    var qbVariantId = parseInt(swatch.getAttribute('data-variant-id') || '0', 10);
    if (qbVariantId) {
      ['quick-buy-drawer', 'quick-buy-popover'].forEach(function(tag) {
        Array.from(productItem.querySelectorAll(tag + ':not([href])')).forEach(function(qb) {
          var pv = qb.querySelector('product-variants');
          if (pv && pv.product && typeof pv.selectVariant === 'function') {
            pv.selectVariant(qbVariantId);
          }
        });
      });
    }
  });

  /**
   * quick-buy 首次加载后强制触发 variant:changed，使折扣价被正确应用。
   * product-variants.selectVariant() 在选中变体未变化时会 early-return，不触发 variant:changed，
   * 导致服务端渲染的折扣价无法通过事件机制修正。
   * 通过暂时清空 masterSelector.value 让 early-return 检查失败，从而强制派发 variant:changed。
   */
  document.addEventListener('openable-element:load:end', function(e) {
    var qb = e.target;
    if (!qb || !qb.tagName) return;
    var tag = qb.tagName.toLowerCase();
    if (tag !== 'quick-buy-drawer' && tag !== 'quick-buy-popover') return;

    var pv = qb.querySelector('product-variants');
    if (!pv) return;

    var attempts = 0;
    var timer = setInterval(function() {
      if (++attempts > 15) { clearInterval(timer); return; }
      if (!pv.product || !pv.masterSelector) return;
      clearInterval(timer);

      var variantId = parseInt(pv.masterSelector.value || '0', 10);

      if (!variantId) return;
      pv.masterSelector.value = '';
      pv.selectVariant(variantId);

      // selectVariant 触发的 variant:changed 事件链（含 ProductMeta._updatePrices）是同步的。
      // setTimeout(0) 在该同步链完成后执行，直接将折扣价写入弹窗价格列表，
      // 避免 ProductMeta 用无折扣价覆写服务端渲染价格后我们的 document handler 未能及时纠正的情形。
      setTimeout(function() {
        var productMeta = qb.querySelector('product-meta');
        if (!productMeta) return;

        var priceList = productMeta.querySelector('[data-product-price-list]');
        if (!priceList) return;

        var discountPct = 0;
        var discountSource = (qb.querySelector('[data-qb-discounts]') || {dataset: {}}).dataset.qbDiscounts
          || qb.dataset.variantDiscounts;
        if (discountSource) {
          try { discountPct = JSON.parse(discountSource)[String(variantId)] || 0; } catch (_) {}
        }

        if (!discountPct) discountPct = ((window.variantDiscounts || {})[String(variantId)]) || 0;
        if (QB_DISCOUNT_HANDLES.indexOf(productMeta.getAttribute('data-product-handle')) === -1) discountPct = 0;
        if (discountPct <= 0) return;

        var variant = (pv.product.variants || []).find(function(v) { return v.id === variantId; });
        if (!variant) return;

        var settings = (window.themeVariables || {}).settings || {};
        var strings  = (window.themeVariables || {}).strings  || {};
        var fmt = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
        var priceClass = productMeta.getAttribute('price-class') || '';
        var discountedCents = variant.price - Math.floor(variant.price * discountPct / 100);

        priceList.innerHTML =
          '<span class="price price--highlight ' + priceClass + '">' +
            '<span class="visually-hidden">' + (strings.productSalePrice || '') + '</span>' +
            formatMoney(discountedCents, fmt) +
          '</span>' +
          '<span class="price price--compare">' +
            '<span class="visually-hidden">' + (strings.productRegularPrice || '') + '</span>' +
            formatMoney(variant.price, fmt) +
          '</span>' +
          '<span class="label label--highlight">' + discountPct + '% off in cart</span>';

        var labelList = productMeta.querySelector('[data-product-label-list]');
        if (labelList) labelList.innerHTML = '';
      }, 0);
    }, 100);
  }, true);
}());
